import React, { FC } from 'react'

import { IconDashboardProps } from './IconDashboard.types'
import * as Styled from './styles/IconDashboard.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDashboard: FC<IconDashboardProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDashboardProps['size'],
  isResponsive = false,
}: IconDashboardProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M35.013 11h-6.025C27.89 11 27 11.89 27 12.988v4.024C27 18.11 27.89 19 28.988 19h6.025C36.11 19 37 18.11 37 17.012v-4.024C37 11.89 36.11 11 35.013 11Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M19.012 29h-6.024C11.89 29 11 29.89 11 30.988v4.025C11 36.11 11.89 37 12.988 37h6.024C20.11 37 21 36.11 21 35.013v-4.025C21 29.89 20.11 29 19.012 29Zm-.642-18h-4.74A2.63 2.63 0 0 0 11 13.63v8.74A2.63 2.63 0 0 0 13.63 25h4.74A2.63 2.63 0 0 0 21 22.37v-8.74A2.63 2.63 0 0 0 18.37 11Zm16 12h-4.74A2.63 2.63 0 0 0 27 25.63v8.74A2.63 2.63 0 0 0 29.63 37h4.74A2.63 2.63 0 0 0 37 34.37v-8.74A2.63 2.63 0 0 0 34.37 23Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M10.938 7H41.02v30.07a4 4 0 0 1-4 4H10.937a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDashboard
